<template>
    <form
        method="post"
        autocomplete="off"
        enctype="multipart/form-data"
        @submit.prevent="addorUpdateLocation"
    >
        <div v-if="!addNewDealer" class="row pt-2">
            <div class="col-md-12">
                <div class="form-group">
                    <!-- <div class="d-flex justify-content-between">
                        <label class="text-muted">Search Dealer</label>
                        <span class="add-button cursor-pointer" @click="addNewDealer = true; clearFields()">
                            <i class="fa fa-plus-circle" aria-hidden="true"></i> Add New Location
                        </span>
                    </div> -->
                    <label class="text-muted">Search Dealer</label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="searchDealerTerm"
                        placeholder="Search Dealer"
                        autocomplete="off"
                        @keyup="searchLocation()"
                    />
                    <!-- <label class="add-button cursor-pointer pt-3 text-decoration-underline" @click="addNewDealer = true; clearFields()">
                        Can't find the dealer?
                    </label> -->
                </div>
                <!-- <ul class="search-results" v-if="searchLocationsByTerm.length">
                    <li
                        v-for="item in searchLocationsByTerm"
                        :key="item.id"
                        @click="selectLocation(item)"
                    >
                        <div class="row">
                            <div class="col-md-12">
                                <span class="sku">{{ item.name }}</span>
                                <span class="product-name"
                                    >{{ item.address }}, {{ item.city }},
                                    {{ item.state }}, {{ item.zip_code }}</span
                                >
                            </div>
                        </div>
                    </li>
                </ul> -->
                <ul class="search-results" v-if="allLocations.length">
                    <li
                        v-for="item in allLocations"
                        :key="item.id"
                        @click="selectLocation(item)"
                    >
                        <div class="row">
                            <div class="col-md-12">
                                <span class="sku">{{ item.name }}</span>
                                <span class="product-name"
                                    >{{ item.address }}, {{ item.city }},
                                    {{ item.state }}, {{ item.zip_code }}</span
                                >
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="col-md-12 pt-3">
                <b>{{ searchDealerText }}</b
                ><br />
                <label>{{ searchDealerTextAddress }}</label>
            </div>
            <div v-if="priceListName" class="col-md-12 pt-3">
                <b>Price List</b><br />
                <label>{{ priceListName }}</label>
            </div>
        </div>
        <template v-if="showSalesRep">
            <div class="row pt-3">
                <div class="col-md-12">
                    <div class="form-group">
                        <h5>Sales Rep</h5>
                        <select
                            class="form-control"
                            v-model="form.sales_rep_id"
                            required
                        >
                            <option value="null">Select Sales Rep</option>
                            <template
                                v-for="(item, idx) in allSalesReps"
                                :key="idx"
                            >
                                <option :value="item.id">
                                    {{ item.first_name }} {{ item.last_name }}
                                </option>
                            </template>
                        </select>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="addNewDealer">
            <div class="row pt-2">
                <div class="col-md-12">
                    <div class="form-group">
                        <div class="d-flex justify-content-between">
                            <label
                                class="form-control-label text-muted"
                                for="odoo_dealer_id"
                                >Odoo Dealer ID</label
                            >
                            <span
                                class="add-button cursor-pointer"
                                @click="
                                    addNewDealer = false;
                                    clearFields();
                                "
                            >
                                <i class="fa fa-search" aria-hidden="true"></i>
                                Search Dealer
                            </span>
                        </div>
                        <input
                            type="text"
                            name="odoo_dealer_id"
                            v-model="form.odoo_dealer_id"
                            class="form-control"
                            required
                            autofocus
                        />
                    </div>
                </div>
            </div>
            <div class="row pt-2">
                <div class="col-md-12">
                    <div class="form-group">
                        <label
                            class="form-control-label text-muted"
                            for="pricelist_id"
                            >Pricelist</label
                        >
                        <select
                            class="form-control"
                            v-model="form.pricelist_id"
                            @change="selectCategory"
                            required
                        >
                            <template
                                v-for="(item, idx) in pricelistsTable"
                                :key="idx"
                            >
                                <option :value="item.id">
                                    {{ item.pricelist_name }}
                                </option>
                            </template>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row pt-2">
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="form-control-label text-muted" for="name"
                            >Name</label
                        >
                        <input
                            type="text"
                            name="name"
                            v-model="form.name"
                            class="form-control"
                            required
                            autofocus
                        />
                    </div>
                </div>
            </div>
            <div class="row pt-2">
                <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <label class="form-control-label text-muted" for="email"
                            >Email</label
                        >
                        <input
                            type="text"
                            name="email"
                            v-model="form.email"
                            class="form-control"
                            autofocus
                        />
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <label class="form-control-label text-muted" for="phone"
                            >Phone</label
                        >
                        <input
                            type="text"
                            name="phone"
                            v-model="form.phone"
                            v-mask="'000-000-0000'"
                            class="form-control"
                            autofocus
                        />
                    </div>
                </div>
            </div>
            <div class="row pt-2">
                <div class="col-md-12">
                    <div class="form-group">
                        <label
                            class="form-control-label text-muted"
                            for="address"
                            >Address</label
                        >
                        <input
                            type="text"
                            name="address"
                            v-model="form.address"
                            class="form-control"
                            required
                            autofocus
                        />
                    </div>
                </div>
            </div>
            <div class="row pt-2">
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="form-control-label text-muted" for="city"
                            >City</label
                        >
                        <input
                            type="text"
                            name="city"
                            v-model="form.city"
                            class="form-control"
                            required
                            autofocus
                        />
                    </div>
                </div>
            </div>
            <div class="row pt-2">
                <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <label
                            class="form-control-label text-muted"
                            for="zip_code"
                            >Zip Code</label
                        >
                        <input
                            type="text"
                            name="zip_code"
                            v-model="form.zip_code"
                            class="form-control"
                            required
                            autofocus
                        />
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <label class="form-control-label text-muted" for="state"
                            >State</label
                        >
                        <input
                            type="text"
                            name="state"
                            v-model="form.state"
                            class="form-control"
                            required
                            autofocus
                        />
                    </div>
                </div>
            </div>
        </template>
        <button
            type="submit"
            class="mt-5 btn btn-outline-orange text-orange text-uppercase float-right"
            :class="form.name == '' || form.name === null ? 'disabled' : ''"
        >
            {{ modalType == "edit" ? "Update Location" : "Add Location" }}
        </button>
    </form>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

export default {
    props: ["modalType", "modalData"],
    emits: ["closeModal"],
    components: {},
    setup() {
        const store = useStore();

        let pricelistsTable = computed(function () {
            return store.state.pricelistsTable;
        });
        let allLocations = computed(function () {
            return store.state.allLocations;
        });
        let allSalesReps = computed(function () {
            return store.getters["salesRep/allSalesReps"];
        });

        function addLocation(form) {
            store.dispatch("addLocation", form);
        }

        function updateLocation(form) {
            store.dispatch("updateLocation", form);
        }

        onMounted(() => {
            store.dispatch("getPricelistsTable");
            // store.dispatch("getAllLocations");
            store.dispatch("salesRep/getAllSalesReps");
            store.commit("setAllLocations", []);
        });

        return {
            store,
            pricelistsTable,
            allLocations,
            allSalesReps,
            addLocation,
            updateLocation,
        };
    },
    data() {
        return {
            form: {
                odoo_dealer_id: null,
                pricelist_id: null,
                loc_type: "",
                id: null,
                name: null,
                email: null,
                phone: null,
                address: null,
                city: null,
                state: null,
                zip_code: null,
                sales_rep_id: null,
            },
            searchDealerTerm: "",
            searchDealerText: "",
            searchDealerTextAddress: "",
            searchDealer: "",
            addNewDealer: false,
            showSalesRep: false,
            priceListName: "",
        };
    },
    computed: {
        searchLocationsByTerm() {
            if (this.searchDealerTerm === "") {
                return [];
            }

            let matches = 0;

            return this.allLocations.filter((item) => {
                if (
                    ((item.name !== null &&
                        item.name
                            .toLowerCase()
                            .includes(this.searchDealerTerm.toLowerCase())) ||
                        (item.address !== null &&
                            item.address
                                .toLowerCase()
                                .includes(
                                    this.searchDealerTerm.toLowerCase()
                                )) ||
                        (item.city !== null &&
                            item.city
                                .toLowerCase()
                                .includes(
                                    this.searchDealerTerm.toLowerCase()
                                )) ||
                        (item.state !== null &&
                            item.state
                                .toLowerCase()
                                .includes(
                                    this.searchDealerTerm.toLowerCase()
                                )) ||
                        (item.zip_code !== null &&
                            item.zip_code
                                .toLowerCase()
                                .includes(
                                    this.searchDealerTerm.toLowerCase()
                                ))) &&
                    matches < 10
                ) {
                    matches++;
                    return item;
                }
            });
        },
    },
    mounted() {
        this.clearFields();

        if (this.modalType == "edit") {
            this.populateData();
        }
    },
    methods: {
        addorUpdateLocation() {
            if (this.modalType == "add") {
                // this.form.id = null;
                this.form.user_id = this.modalData.user_id;
                this.addLocation(this.form);
                window.emitter.emit("alertSuccess", {
                    message: "Location is added successfully!",
                });
            } else {
                this.updateLocation(this.form);
            }
            this.$emit("closeModal");
        },
        populateData() {
            this.form.id = this.modalData.id;
            this.form.name = this.modalData.name;
            this.form.email = this.modalData.email;
            this.form.phone = this.modalData.phone;
            this.form.address = this.modalData.address;
            this.form.city = this.modalData.city;
            this.form.state = this.modalData.state;
            this.form.zip_code = this.modalData.zip_code;
        },
        clearFields() {
            this.form.loc_type = "";
            this.form.odoo_dealer_id = null;
            this.form.pricelist_id = null;
            this.form.name = null;
            this.form.email = null;
            this.form.phone = null;
            this.form.address = null;
            this.form.city = null;
            this.form.state = null;
            this.form.zip_code = null;
            this.form.sales_rep_id = null;

            this.searchDealerTerm = "";
            this.searchDealerText = "";
            this.searchDealerTextAddress = "";
            this.searchDealer = "";
            this.priceListName = "";
        },
        selectLocation(loc) {
            this.searchDealerTerm = "";
            this.searchDealerText = loc.name;
            this.searchDealerTextAddress =
                loc.address +
                ", " +
                loc.city +
                ", " +
                loc.state +
                ", " +
                loc.zip_code;
            this.searchDealer = loc;
            this.priceListName = loc.pricelist.pricelist_name;

            this.form.loc_type = "existing";
            this.form.odoo_dealer_id = loc.odoo_dealer_id;
            this.form.pricelist_id = loc.pricelist_id;
            this.form.id = loc.id;
            this.form.name = loc.name;
            this.form.email = loc.email;
            this.form.phone = loc.phone;
            this.form.address = loc.address;
            this.form.city = loc.city;
            this.form.state = loc.state;
            this.form.zip_code = loc.zip_code;
            this.form.sales_rep_id = loc.sales_rep_id;

            this.showSalesRep = loc.sales_rep_id ? false : true;

            this.store.commit("setAllLocations", []);
        },
        searchLocation() {
            if (this.searchDealerTerm.length >= 3) {
                this.store.dispatch("getLocationByInput", {search: this.searchDealerTerm})
            } else {
                this.store.commit("setAllLocations", []);
            }
                
        }
    },
};
</script>
